<template>
    <teleport to="#commands">
        <slot />
    </teleport>
</template>

<script lang="ts">

import {usePageHost} from "../utils/usePageHost";
import {defineComponent} from "vue";

export default defineComponent({
    name: "AunoaCommandsPane",
    setup: () => usePageHost().withTeleport("commands")
});

</script>
